import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ChevronUpIcon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
function TrustBlock({
  open,
  onToggle
}: {
  open: boolean;
  onToggle: () => void;
}) {
  return <div className="mt-6 space-y-4" data-id="element-348">
      {/* Garantía accordion */}
      <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-349">
        <button onClick={onToggle} className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-gray-50 transition-colors" data-id="element-350">
          <span className="flex items-center gap-2 font-bold text-gray-900" data-id="element-351">
            <span className="text-lg" data-id="element-352">🏆</span>
            Garantía de satisfacción 7 días
          </span>
          {open ? <ChevronUpIcon className="w-5 h-5 text-gray-500" data-id="element-353" /> : <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-354" />}
        </button>
        {open && <div className="px-5 pb-5 text-left text-sm text-gray-600 leading-relaxed" data-id="element-355">
            <p className="mb-3" data-id="element-356">
              Si aplicás el contenido y sentís que no te aporta claridad o no es
              para vos, podés{' '}
              <strong className="text-gray-900" data-id="element-357">
                solicitar una devolución dentro de los primeros 7 días.
              </strong>
            </p>
            <p data-id="element-358">Quiero que compres segura/o, no con dudas.</p>
          </div>}
      </div>

      {/* Pago seguro garantizado */}
      <fieldset className="border border-gray-200 rounded-xl px-5 py-4" data-id="element-359">
        <legend className="flex items-center gap-2 px-2 text-sm font-semibold text-gray-600" data-id="element-360">
          <ShieldCheckIcon className="w-4 h-4 text-brand-green" data-id="element-361" />
          Pago seguro garantizado
        </legend>
        <img src="https://cdn.magicpatterns.com/uploads/hzgvUoMWhjNHxhRDn2LPwT/Imagen_28-3-26_a_las_5.16_p._m._(1).jpg" alt="Métodos de pago: Mercado Pago, Visa, Mastercard, Cabal, American Express, Tarjeta Shopping, Cencosud, Argencard, Provincia NET, Link, Banelco, Pago Fácil, Rapipago, Naranja" className="w-full max-w-sm mx-auto" data-id="element-362" />
      </fieldset>
    </div>;
}
export function PricingSection() {
  const [guaranteeOpen1, setGuaranteeOpen1] = useState(false);
  const [guaranteeOpen2, setGuaranteeOpen2] = useState(false);
  return <section id="pricing" className="w-full bg-brand-bg pt-6 md:pt-8 pb-8 md:pb-10 px-6" data-id="element-363">
      <div className="max-w-7xl mx-auto" data-id="element-364">
        <motion.div className="flex flex-col lg:flex-row gap-8 items-start" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-365">
          {/* Pricing card */}
          <div className="w-full max-w-3xl mx-auto bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-lg shadow-brand-green/5" data-id="element-366">
            {/* Banner */}
            <div className="bg-brand-green py-3 text-center" data-id="element-367">
              <span className="text-white text-sm font-bold uppercase tracking-widest" data-id="element-368">
                Promoción por tiempo limitado
              </span>
            </div>

            <div className="px-8 py-10 text-center" data-id="element-369">
              {/* Super Oferta badge */}
              <div className="flex justify-center mb-6" data-id="element-370">
                <span className="inline-flex flex-col items-center bg-red-500 text-white text-xs font-bold px-4 py-2 rounded-full animate-pulse leading-tight" data-id="element-371">
                  <span data-id="element-372">🔥 SUPER OFERTA</span>
                  <span className="text-[10px] font-semibold opacity-90" data-id="element-373">
                    +2173 descargas
                  </span>
                </span>
              </div>

              {/* Guía Completa Paso a Paso */}
              <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3" data-id="element-374">
                🎓 Curso Completo{' '}
                <span className="text-brand-green" data-id="element-375">Paso a Paso</span>
              </h3>
              <ul className="text-sm text-gray-600 mb-6 space-y-2 text-left" data-id="element-376">
                <li className="flex items-start gap-2" data-id="element-377">
                  <span data-id="element-378">📚</span>
                  <span data-id="element-379">
                    Acceso a curso completo con clases grabadas paso a paso
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-380">
                  <span data-id="element-381">🎥</span>
                  <span data-id="element-382">
                    Mentorías grupales semanales EN VIVO — correcciones,
                    estrategia y dudas resueltas en directo
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-383">
                  <span data-id="element-384">💬</span>
                  <span data-id="element-385">
                    Comunidad de WhatsApp para resolver tus dudas 24/7
                  </span>
                </li>
              </ul>

              <div className="mb-6" data-id="element-386">
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-387">
                  <p className="text-xl text-gray-400 line-through" data-id="element-388">
                    $150.000 ARS
                  </p>
                  <span className="inline-block bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full animate-pulse" data-id="element-389">
                    70% OFF
                  </span>
                </div>
                <p className="flex items-baseline justify-center gap-1" data-id="element-390">
                  <span className="text-lg text-gray-400" data-id="element-391">$</span>
                  <span className="text-5xl md:text-6xl font-bold text-gray-900" data-id="element-392">
                    24.900
                  </span>
                  <span className="text-lg text-gray-500 ml-1" data-id="element-393">ARS</span>
                </p>
                <p className="text-sm font-semibold text-brand-green mt-4" data-id="element-394">
                  Precio lanzamiento por tiempo limitado
                </p>
              </div>

              <a href="https://www.emprende-digital.com/cart/51742249156888:1" target="_blank" rel="noopener noreferrer" className="block w-full max-w-xs mx-auto bg-brand-green hover:bg-brand-green-hover text-white font-bold text-lg py-4 rounded-xl transition-colors duration-200 shadow-lg shadow-brand-green/20 text-center mb-4" data-id="element-395">
                🔥 Acceder Ahora
              </a>

              <p className="text-sm text-gray-600 mb-2" data-id="element-396">
                🎁 + de regalo 3 bonos valorados en un total de $67.000
                totalmente{' '}
                <strong className="text-brand-green" data-id="element-397">¡GRATIS!</strong>
              </p>
              <p className="text-sm text-gray-600 mb-2" data-id="element-398">
                🎓 + 2 clases incluidas:{' '}
                <strong className="text-gray-900" data-id="element-399">
                  Clase completa de campañas de venta en Meta Ads
                </strong>{' '}
                ($70.000) y{' '}
                <strong className="text-gray-900" data-id="element-400">
                  Taller grabado: Meta Ads + Shopify
                </strong>{' '}
                ($50.000) totalmente{' '}
                <strong className="text-brand-green" data-id="element-401">¡GRATIS!</strong>
              </p>
              <p className="text-sm text-gray-500 mt-2" data-id="element-402">
                📩 Acceso inmediato al eBook después del pago, se envía a tu
                correo electrónico
              </p>

              {/* Trust block for Guía Completa */}
              <TrustBlock open={guaranteeOpen1} onToggle={() => setGuaranteeOpen1(!guaranteeOpen1)} data-id="element-403" />
            </div>
          </div>
        </motion.div>

        {/* Tienda Líder Platinum badge */}
        <motion.div className="mt-8 flex justify-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-404">
          <img src="https://cdn.magicpatterns.com/uploads/6a1pUYDihJzNUtN2uLf8oo/Imagen_29-3-26_a_las_12.25_a._m..jpg" alt="Tienda Líder Platinum — 3758 ventas en los últimos 60 días, brinda un buen servicio, entrega los productos a tiempo" className="w-full max-w-3xl h-auto rounded-2xl shadow-md" data-id="element-405" />
        </motion.div>
      </div>
    </section>;
}